import { useCallback } from "react";
import { FinancialAccount } from "@common/types/financialAccount";
import { SpreadsheetData } from "@components/spreadsheet/types";
import {
    CashItemImporterRow,
    createCashItemImporterRow,
    withLedgerAccountsClearedOnEntityChange,
    withNonCheckingAccountClearedWhenAmountBecomesCheck,
} from "./cashItemImporterRows";

interface UseCashItemImporterChangeHandlerParams {
    setRows: React.Dispatch<React.SetStateAction<CashItemImporterRow[]>>;
    financialAccountsById: ReadonlyMap<number, FinancialAccount>;
}

export function useCashItemImporterChangeHandler({
    setRows,
    financialAccountsById,
}: UseCashItemImporterChangeHandlerParams) {
    return useCallback(
        (newData: SpreadsheetData) => {
            setRows((prevRows) => {
                const prevRowsById = new Map(
                    prevRows.map((row) => [row._id, row]),
                );
                return newData.map((data) => {
                    const row = createCashItemImporterRow(data);
                    const previousRow = prevRowsById.get(row._id);
                    if (previousRow === undefined) {
                        return row;
                    }
                    return withLedgerAccountsClearedOnEntityChange({
                        row: withNonCheckingAccountClearedWhenAmountBecomesCheck(
                            {
                                row,
                                previousRow,
                                financialAccountsById,
                            },
                        ),
                        previousRow,
                        financialAccountsById,
                    });
                });
            });
        },
        [setRows, financialAccountsById],
    );
}
